import React from 'react';
import { Fab } from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';

const FloatingBookButton = ({ onClick, isMobile = false }) => {
  if (!isMobile) {
    return null; // Only show on mobile
  }

  return (
    <Fab
      variant="extended"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#000000',
        color: '#FFFFFF',
        fontWeight: 600,
        px: 3,
        py: 1,
        borderRadius: 6,
        boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
        zIndex: 1000,
        fontSize: '0.875rem',
        '&:hover': {
          backgroundColor: '#1F1F1F',
          boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 10px 10px -5px rgb(0 0 0 / 0.04)'
        }
      }}
    >
      <CalendarIcon sx={{ mr: 1, fontSize: '1rem' }} />
      Réserver
    </Fab>
  );
};

export default FloatingBookButton;